import { jsPDF } from "jspdf";

//This is renamed to Guide Report on the front-end

export default function generateDailyTripsReport(data, selectedDate = null) {
  const doc = new jsPDF('landscape');
  console.log("Starting jsPDF");
  console.log(data);

  // Check if data has the new structure with backend calculations
  const hasBackendData = data.reportData && data.totalGuides !== undefined;
  console.log(hasBackendData);
  const reportData = hasBackendData ? data.reportData : data;
  const totalGuides = hasBackendData ? data.totalGuides : 0;
  const heliBreakdown = hasBackendData ? data.heliBreakdown : [];
  const groupBreakdown = hasBackendData ? data.groupBreakdown : [];

  // Use the selected date if provided, otherwise try to extract from data, otherwise use current date
  let formattedDate;
  if (selectedDate) {
    formattedDate = selectedDate;
  } else {
    let latestReportDate = null;
    reportData.forEach(helicopter => {
      if (helicopter.reportDate) {
        const currentDate = new Date(helicopter.reportDate);
        if (!latestReportDate || currentDate > latestReportDate) {
          latestReportDate = currentDate;
        }
      }
    });
    formattedDate = latestReportDate ? latestReportDate.toISOString().split('T')[0] : new Date().toISOString().split('T')[0];
  }

  // Fallback calculation if backend data not available
  console.log(totalGuides);
  let calculatedTotalGuides = totalGuides;
  if (!hasBackendData) {
    reportData.forEach(helicopter => {
      helicopter.groups.forEach(group => {
        if (group.guide !== 'N/A' && group.guide) {
          calculatedTotalGuides++;
        }
        if (group.guide_additional !== 'N/A' && group.guide_additional) {
          calculatedTotalGuides++;
        }
      });
    });
  }
  console.log(calculatedTotalGuides);

  

  // Adding a cover page
  const addCoverPage = (doc, helicopterIds, groupIds, totalClients, totalGuides, heliBreakdown, groupBreakdown) => {
    doc.setFontSize(20);
    doc.text("Guide Report", 10, 20);
    doc.setFontSize(16);
    doc.text(`Report Date: ${formattedDate}`, 10, 30);

    let y = 50;

    // Program Breakdown
    doc.setFontSize(14);
    doc.text('Program Breakdown', 10, y);
    doc.setFontSize(12);
    y +=10;
    doc.text(`Total Guests: ${totalClients}`, 10, y);
    y += 20;

    // Heli Breakdown - formatted as line items
    doc.setFontSize(14);
    doc.text('Heli Breakdown', 10, y);
    y += 10;
    doc.setFontSize(12);

    if (heliBreakdown && heliBreakdown.length > 0) {
      heliBreakdown.forEach(heli => {
        doc.text(`• Heli #${heli.heliIndex} (${heli.helicopterId}): ${heli.guidesCount} guides`, 15, y);
        y += 8;
      });
    } else {
      helicopterIds.forEach(heliId => {
        doc.text(`• ${heliId}`, 15, y);
        y += 8;
      });
    }
    console.log(helicopterIds);
    y += 10;

    // Group IDs Breakdown - formatted as line items
    doc.setFontSize(14);
    doc.text('Group IDs Breakdown', 10, y);
    y += 10;
    doc.setFontSize(12);

    if (groupBreakdown && groupBreakdown.length > 0) {
      groupBreakdown.forEach(breakdown => {
        doc.text(`• Heli #${breakdown.heliIndex}: ${breakdown.groups.join(', ')}`, 15, y);
        y += 8;
      });
    } else {
       groupIds.forEach(groupId => {
        doc.text(`• ${groupId}`, 15, y);
        y +=8;
       })
    }
    
    y += 10;

    // Total Guides
    doc.setFontSize(14);
    doc.text('Total Guides', 10, y);
    doc.setFontSize(12);
    doc.text(`Number of Guides: ${totalGuides}`, 10, y + 10);

    doc.addPage('landscape'); // Add a new page for the detailed reports
  };

  // Column definitions for consistent layout
  const columns = [
    { header: 'Last Name', width: 27, key: 'lastName' },
    { header: 'First Name', width: 27, key: 'firstName' },
    { header: 'Group Code', width: 40, key: 'groupcode' },
    { header: 'Training', width: 22, key: 'training' },
    { header: 'New Guest', width: 28, key: 'returning_guest' },
    { header: 'Country', width: 48, key: 'country' },
    { header: 'Ability', width: 20, key: 'rider_ability' },
    { header: 'Ski/Snowboard', width: 28, key: 'ridertype' },
    { header: 'DOB', width: 21, key: 'dateOfBirth' },
    { header: 'Room', width: 21, key: 'room' }
  ];

  // Function to wrap text within a column width
  const wrapText = (doc, text, maxWidth) => {
    if (!text) return [''];

    const words = text.toString().split(' ');
    const lines = [];
    let currentLine = '';

    words.forEach(word => {
      const testLine = currentLine ? `${currentLine} ${word}` : word;
      const textWidth = doc.getTextWidth(testLine);

      if (textWidth <= maxWidth - 4) { // Leave 4 units padding
        currentLine = testLine;
      } else {
        if (currentLine) {
          lines.push(currentLine);
          currentLine = word;
        } else {
          // Single word is too long, truncate it
          lines.push(word.substring(0, Math.floor(word.length * maxWidth / textWidth)));
        }
      }
    });

    if (currentLine) {
      lines.push(currentLine);
    }

    return lines.length > 0 ? lines : [''];
  };

  // Function to draw text in a cell with proper boundaries
  const drawCellText = (doc, text, x, y, width, height, isMinor = false) => {
    const lines = wrapText(doc, text, width);
    const lineHeight = 3.5; // Reduced from 4

    // Draw cell background for minors
    if (isMinor) {
      doc.setFillColor(0, 128, 0);
      doc.rect(x, y, width, height, 'F');
      doc.setTextColor(255, 255, 255); // White text on green background
    }

    // Draw each line of text
    lines.forEach((line, index) => {
      if (index * lineHeight < height - 1.5) { // Make sure text fits in cell height
        doc.text(line, x + 1.5, y + 3 + (index * lineHeight));
      }
    });

    // Reset text color
    if (isMinor) {
      doc.setTextColor(0, 0, 0);
    }

    return lines.length * lineHeight;
  };

  // Drawing the headers for each group section
  const drawHeaders = (doc, y) => {
    doc.setFontSize(8);
    doc.setFont('helvetica', 'bold');

    let x = 10;
    columns.forEach(col => {
      doc.setDrawColor(0);
      doc.setFillColor(211, 211, 211);
      doc.rect(x, y, col.width, 5, 'FD');
      doc.setTextColor(0, 0, 0);
      doc.text(col.header, x + 2, y + 3.5);
      x += col.width;
    });

    doc.setFont('helvetica', 'normal');
    return y + 5;
  };

  // Assuming 'data' is an array where each entry represents a helicopter's data.
  const allHelicopterIds = reportData.map(helicopter => {
    const heliIndex = helicopter.heliIndex ? `Heli #${helicopter.heliIndex}` : 0;
    const tripType = helicopter.tripType ? helicopter.tripType : '';
    return `${heliIndex} - ${tripType}`;
});

  
  let totalClients = 0;

  reportData.forEach(helicopter => {
    helicopter.groups.forEach(group => {
      totalClients += group.clients.length;
    });
  });

  const allGroupIds = reportData.map(helicopter => {
    const ids = (helicopter.groups || []).map(group => `H${helicopter.heliIndex}G${group.groupIndex}`).join(', ');
    return `${helicopter.tripType}: ${ids}`;
  })

  
    // Pass this data to the cover page function
    addCoverPage(doc, allHelicopterIds, allGroupIds, totalClients, calculatedTotalGuides, heliBreakdown, groupBreakdown);

    //Function to check if client is minor
    function isMinor(dateOfBirth) {
      if (!dateOfBirth) return false;
      const dob = new Date(dateOfBirth);
      const now = new Date();
      const age = now.getFullYear() - dob.getFullYear();
    
      // Check if birthday has occurred this year
      if (now.getMonth() < dob.getMonth() || (now.getMonth() === dob.getMonth() && now.getDate() < dob.getDate())) {
        return age - 1 < 18; // Subtract 1 from age if birthday hasn't occurred yet
      } else {
        return age < 18;
      }
    }

  // Function to draw page header
  const drawPageHeader = (doc, helicopter, formattedDate) => {
    doc.setFontSize(10);
    doc.text(`Heli #${helicopter.heliIndex} - ${helicopter.tripType}`, 10, 10);
    doc.text(`Report Date: ${formattedDate}`, 120, 10);
    doc.text("Trip Notes:", 250, 10);
    doc.setFontSize(8);
    let heliNote = helicopter.note ? helicopter.note : "No Note";
    doc.text(heliNote, 250, 15);
    return 18; // Return Y position after header (reduced further)
  };

  data.forEach((helicopter, index) => {
    if (index > 0) doc.addPage('landscape');
    let y = drawPageHeader(doc, helicopter, formattedDate);


    helicopter.groups.forEach(group => {
      // Calculate total height needed for this group
      let groupHeaderHeight = 6; // Group header
      let tableHeaderHeight = 5; // Table headers
      let clientRowsHeight = 0;

      // Calculate height for all client rows
      group.clients.forEach(client => {
        let maxRowHeight = 4; // Minimum row height (reduced)
        columns.forEach(col => {
          let cellText = '';
          if (col.key === 'room') {
            cellText = client.beacon || '';
          } else if (col.key === 'ridertype') {
            cellText = client.ridertype || 'N/A';
          } else if (col.key === 'training') {
            const trainingText = client.training || '';
            if (trainingText) {
              const formattedDates = trainingText.split(', ').map(dateStr => {
                if (dateStr.trim()) {
                  try {
                    const date = new Date(dateStr.trim());
                    return date.toISOString().split('T')[0];
                  } catch (e) {
                    return dateStr.trim();
                  }
                }
                return '';
              }).filter(date => date);
              cellText = formattedDates.join(', ');
            } else {
              cellText = '';
            }
          } else {
            cellText = client[col.key] || '';
          }
          const lines = wrapText(doc, cellText, col.width);
          const requiredHeight = Math.max(4, lines.length * 3.5 + 1.5);
          maxRowHeight = Math.max(maxRowHeight, requiredHeight);
        });
        clientRowsHeight += maxRowHeight;
      });

      const totalGroupHeight = groupHeaderHeight + tableHeaderHeight + clientRowsHeight + 3; // 3 for spacing

      // Check if entire group fits on current page, if not start new page
      if (y + totalGroupHeight > 190) {
        doc.addPage('landscape');
        y = drawPageHeader(doc, helicopter, formattedDate);
      }

      // Draw group header
      doc.setFontSize(9);
      doc.setFont('helvetica', 'bold');
      doc.text(`Group #${group.groupIndex} (H${helicopter.heliIndex}G${group.groupIndex})`, 10, y + 4);
      y += 6;

      // Draw table headers
      y = drawHeaders(doc, y);
      y += 1;

      group.clients.forEach(client => {
        doc.setFontSize(8);

        // Calculate the row height needed based on text wrapping
        let maxRowHeight = 4; // Minimum row height (reduced)
        let x = 10;

        // First pass: calculate required height for this row
        columns.forEach(col => {
          let cellText = '';
          if (col.key === 'room') {
            cellText = client.beacon || '';
          } else if (col.key === 'ridertype') {
            cellText = client.ridertype || 'N/A';
          } else if (col.key === 'training') {
            // Format training dates to yyyy-mm-dd for height calculation
            const trainingText = client.training || '';
            if (trainingText) {
              const formattedDates = trainingText.split(', ').map(dateStr => {
                if (dateStr.trim()) {
                  try {
                    const date = new Date(dateStr.trim());
                    return date.toISOString().split('T')[0];
                  } catch (e) {
                    return dateStr.trim();
                  }
                }
                return '';
              }).filter(date => date);
              cellText = formattedDates.join(', ');
            } else {
              cellText = '';
            }
          } else {
            cellText = client[col.key] || '';
          }

          const lines = wrapText(doc, cellText, col.width);
          const requiredHeight = Math.max(4, lines.length * 3.5 + 1.5);
          maxRowHeight = Math.max(maxRowHeight, requiredHeight);
        });

        // Note: Page break logic removed here since we check for entire group fit before starting

        // Draw cell borders and content
        x = 10;
        columns.forEach(col => {
          // Draw cell border
          doc.setDrawColor(200, 200, 200);
          doc.rect(x, y, col.width, maxRowHeight);

          // Get cell content
          let cellText = '';
          let isMinorCell = false;

          if (col.key === 'room') {
            cellText = client.beacon || '';
            doc.setTextColor(0, 0, 0);
          } else if (col.key === 'ridertype') {
            cellText = client.ridertype || 'N/A';
            doc.setTextColor(0, 0, 0);
          } else if (col.key === 'dateOfBirth') {
            cellText = client.dateOfBirth || '';
            isMinorCell = isMinor(client.dateOfBirth);
            doc.setTextColor(0, 0, 0);
          } else if (col.key === 'training') {
            // Format training dates to yyyy-mm-dd
            const trainingText = client.training || '';
            if (trainingText) {
              // Split by comma and format each date
              const formattedDates = trainingText.split(', ').map(dateStr => {
                if (dateStr.trim()) {
                  try {
                    const date = new Date(dateStr.trim());
                    return date.toISOString().split('T')[0]; // Convert to yyyy-mm-dd
                  } catch (e) {
                    return dateStr.trim(); // Return original if parsing fails
                  }
                }
                return '';
              }).filter(date => date); // Remove empty dates

              cellText = formattedDates.join(', ');
            } else {
              cellText = '';
            }
            doc.setTextColor(0, 0, 0);
          } else {
            cellText = client[col.key] || '';
            doc.setTextColor(0, 0, 0);
          }

          // Draw cell content
          drawCellText(doc, cellText, x, y, col.width, maxRowHeight, isMinorCell);

          x += col.width;
        });

        // Reset text color
        doc.setTextColor(0, 0, 0);
        y += maxRowHeight;
      });

      // Add spacing between groups (reduced)
      y += 3;
    });
  });

  //const today = new Date();
  //const dateString = `${today.getFullYear()}-${(today.getMonth() + 1).toString().padStart(2, '0')}-${today.getDate().toString().padStart(2, '0')}`;
  doc.save(`guide-report-${formattedDate}.pdf`);
}